import axios from "axios";
import { getAuthHeaders, getBasicAuthHeadersElastic } from "../helpers";

/**
 * @function getNewsTags
 * @desc  get news tags list.
 */

export const getNewsTags = () => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_tags`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getNewsArticlesList
 * @desc  shows news article list.
 */

export const getNewsArticlesList = (
  pageNo,
  searchText,
  publish,
  tagIds,
  newsType,
  perPage,
  startDate,
  endDate
) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles/list?page=${pageNo}&perpage=${perPage}?sort_by_order=asc`;

  if (searchText) url = `${url}&search_text=${searchText}`;

  if (publish) url = `${url}&published=${publish}`;
  if (tagIds) url = `${url}&news_tag_ids=${tagIds}`;
  if (newsType) url = `${url}&news_type=${newsType}`;
  if (startDate) url = `${url}&start_time=${startDate}`;
  if (endDate) url = `${url}&end_time=${endDate}`;

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function addNewsArticle
 * @desc  add news article.
 */

export const addNewsArticle = data => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles`;
  return axios.post(url, data, {
    headers: getAuthHeaders()
  });
};

/**
 * @function newsArticlePublish
 * @desc  add news article.
 */

export const newsArticlePublish = (data, newsDesc) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles/publish?ids=${data}`;
  let params = null;
  if (newsDesc && newsDesc.trim()) params = { notify_desc: newsDesc };
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function deleteNewsArticle
 * @desc  delete Promo code.
 */

export const deleteNewsArticle = ids => {
  const selectedIds = Array.isArray(ids) ? ids.join(",") : ids;
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles/delete?ids=${selectedIds}`;
  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders()
    }
  );
};

/**
 * @function getPresignedUrl
 * @param params
 * @desc This services gets presigned url
 */
export const getPresignedUrl = params => {
  const url = `${process.env.REACT_APP_SERVER_URL}/ps_url`;
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function uploadImageToS3
 * @param fileUrl
 * @param fileType
 * @param file
 * @desc This service uploads the file to s3 presigned url
 */
export const uploadImageToS3 = (fileUrl, fileType, file) => {
  return axios.put(fileUrl, file, {
    headers: {
      "Content-Type": fileType
    }
  });
};

/**
 * @function getBasicPharmas
 * @desc This returns basic pharma list
 */
export const getBasicPharmas = (name, perPage) => {
  let url = `${process.env.REACT_APP_ES_SERVER_URL}/${process.env.REACT_APP_BASIC_PHARMA_INDEX}/_search`;
  const params = {
    query: {
      bool: {
        must: []
      }
    },
    from: 0,
    size: perPage
  };
  if (name)
    params.query.bool.must.push({
      match_phrase_prefix: { name }
    });

  return axios.post(url, params);
};

export const getSavedNewsArticlesList = (newsType, pageNo, perPage) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles/${
    newsType === "PHARMA" ? "pharma_interests" : "cme_interests"
  }?page=${pageNo}&perpage=${perPage}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function newsArticlePublish
 * @desc  add news article.
 */

export const getRssFeed = () => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/news_articles/fetch_rss`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const createWeeklyNews = params => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/weekly_news`;
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getWeeklyNews
 * @desc  handles fetching weekly news
 */
export const getWeeklyNews = () => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/weekly_news`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function deleteWeeklyNewsArticle
 * @desc  delete weekly news
 */

export const deleteWeeklyNewsArticle = ids => {
  const selectedIds = Array.isArray(ids) ? ids.join(",") : ids;
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/weekly_news/delete?news_article_ids=${selectedIds}`;
  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders()
    }
  );
};
